import React, { useEffect, useRef, useState } from "react";
import '../../../src/pages/Website/webStyle.css'
import WebsiteNavbar from "./Navbar";
import Footer from "./footer";
import { getData } from "src/webService/webService";
import { toast } from "react-toastify";
import { Box, Button, Dialog, DialogContent } from "@mui/material";
import hanger from '../../components/images/hanger.png';
import Loader from "../Loader/Loader";
import ViewSellerList from "./viewSellerList";


export default function WebsiteCategories() {

    const [TotalItems, setTotalItems] = useState(null);
    const [loading, setLoading] = useState(false);
    const [Categories, setCategories] = useState([]);
    const Token = sessionStorage.getItem('Token');
    const [categoryName, setCategoryName] = useState('');
    const [viewSellerList, setViewSellerList] = useState(true);
    const [categoryId, setCategoryId] = useState();
    const [open, setOpen] = useState(false);
    const [showSkip, setShowSkip] = useState(false);
    const skipTimerRef = useRef(null);
    const [skipCountdown, setSkipCountdown] = useState(5);

    const getCategoryData = async (page) => {
        setLoading(true);
        try {
            const res = await getData('buyer/categories', null, Token);
            if (res.status === 200) {
                console.log(res.data, "res.data");
                setCategories(res.data);
                setCategoryName('Categories');
                setTotalItems(res?.total)
            }
        } catch (error) {
            console.error("Error:", error);
            toast.error("An error occurred. Please try again later.", {});
        } finally {
            setLoading(false);
        }
    }

    const handleClose = () => {
        setOpen(false);
    };

    const handleOpen = () => {
        setOpen(true);
    }


    useEffect(() => {
        getCategoryData();
    }, [])

    const getCategoryById = async (id, advertisement) => {
        setLoading(true);
        debugger;
        try {
            const res = await getData(`buyer/categories`, { category: id }, Token);
            setCategories(res.data);
            setTotalItems(res?.total);
            setCategoryName('Sub-Categories');
            if(advertisement) setAdvertisement(advertisement);
        } catch (error) {
            console.error("Error:", error);
            toast.error("An error occurred. Please try again later.", {});
        } finally {
            setLoading(false);
            if(advertisement) handleOpen();
        }
    }

    useEffect(() => {
            let countdownInterval;
    
            if (open) {
                setShowSkip(false);
                setSkipCountdown(5);
    
                countdownInterval = setInterval(() => {
                    setSkipCountdown((prev) => {
                        if (prev === 1) {
                            clearInterval(countdownInterval);
                            setShowSkip(true);
                            return 0;
                        }
                        return prev - 1;
                    });
                }, 1000);
            }
    
            return () => clearInterval(countdownInterval);
        }, [open]);

    const [advertisement, setAdvertisement] = useState(null);

    const handleViewSellerList = (id, advertisement) => {
        debugger;
        setViewSellerList(!viewSellerList);
        setCategoryId(id)
        if(advertisement) setAdvertisement(advertisement);
    }

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [viewSellerList]);


    return (
        <div>
            <WebsiteNavbar />
            {viewSellerList ? (
                <div>
                    <div className="Banner">
                        <div className="w-50 d-flex justify-content-center align-items-center banner-title">
                            <h1>{categoryName}</h1>
                        </div>
                    </div>
                    {loading ? (
                        <Loader />
                    ) : (
                        <div>
                            <div className="d-flex justify-content-center mt-5">
                                <p className="clip-path" style={{ background: '#f0c99b' }} onClick={() => getCategoryData()}>Categories</p>
                            </div>
                            <div className="container mt-3">
                                <div className="row">
                                    {Categories?.length === 0 ? (
                                        <div>
                                            <h5 className="text-center">No Data found</h5>
                                            <div className="d-flex justify-content-center align-items-center">
                                                <img src={hanger} width='10%' />
                                            </div>
                                            <p onClick={() => getCategoryData()} className="text-center pointer">Back</p>
                                        </div>
                                    ) : (
                                        Categories.map((item, index) => (
                                            <div className="col-lg-3" key={index}>
                                                <div className='cardLayoutWeb' onClick={() => (item?.subCategoryCount === 0) ? handleViewSellerList(item?._id, item?.advertisement) : getCategoryById(item?._id, item?.advertisement)}>
                                                    <div>
                                                        <img src={item?.thumbnail} />
                                                    </div>
                                                    <div className="d-flex align-items-center justify-content-start">
                                                        <div>
                                                            <h5 style={{ fontWeight: '600' }} className='pt-2 pb-1'>{item?.name}</h5>
                                                            {item?.subCategoryCount === 0 ? (
                                                                <Button style={{ fontSize: '12px' }} variant="contained" className='Button' onClick={() => handleViewSellerList(item?._id, item?.advertisement)}>View Seller List</Button>
                                                            ) : (
                                                                <Button style={{ fontSize: '12px' }} variant="contained" className='Button' onClick={() => getCategoryById(item?._id, item?.advertisement)}>View Sub-Categories</Button>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        ))
                                    )}
                                </div>
                            </div>

                            <Dialog open={open} maxWidth="md">
                                <DialogContent sx={{ position: 'relative', p: 0 }}>
                                    <Box position="relative">
                                        {advertisement?.split('.').pop().toLowerCase() === 'mp4' ? (
                                            <video
                                                width="100%"
                                                autoPlay
                                                controls
                                                // onPlay={handleVideoPlay}
                                                onPlay={() => { }}
                                                style={{ borderRadius: '8px' }}
                                            >
                                                <source src={advertisement} />
                                            </video>
                                        ) : (
                                            <img
                                                src={advertisement}
                                                alt="Advertisement"
                                                style={{ width: '100%', borderRadius: '8px' }}
                                            />
                                        )}

                                        {showSkip ? (
                                            <Button
                                                variant="contained"
                                                color="error"
                                                onClick={handleClose}
                                                sx={{
                                                    position: 'absolute',
                                                    top: 16,
                                                    right: 16,
                                                    backgroundColor: 'rgba(0,0,0,0.6)',
                                                    color: '#fff',
                                                    px: 2,
                                                    py: 1,
                                                    borderRadius: '8px',
                                                    fontSize: '14px',
                                                }}
                                            >
                                                Skip
                                            </Button>
                                        ) : (
                                            <Box
                                                sx={{
                                                    position: 'absolute',
                                                    top: 16,
                                                    right: 16,
                                                    backgroundColor: 'rgba(0,0,0,0.6)',
                                                    color: '#fff',
                                                    px: 2,
                                                    py: 1,
                                                    borderRadius: '8px',
                                                    fontSize: '14px',
                                                }}
                                            >
                                                Skip in {skipCountdown}...
                                            </Box>
                                        )}
                                    </Box>
                                </DialogContent>
                            </Dialog>
                        </div>
                    )}
                </div>
            ) : (
                <ViewSellerList id={categoryId} handleViewSellerList={handleViewSellerList} advertisement={advertisement} />
            )}

            <Footer />

        </div>
    )
}